import { render, staticRenderFns } from "./CategoryDefault.vue?vue&type=template&id=01b78797&scoped=true&"
import script from "./CategoryDefault.vue?vue&type=script&lang=ts&"
export * from "./CategoryDefault.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryDefault.vue?vue&type=style&index=0&id=01b78797&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b78797",
  null
  
)

export default component.exports